import { useGSAP } from '@gsap/react';
import cls from 'classnames';
import gsap from 'gsap';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import React, { useContext, useRef } from 'react';

import LeadButton from '@/components/LeadButton';
import Title from '@/components/Title';
import TrustpilotBar from '@/components/TrustpilotBar';
import { MyContext } from '@/config/context-manager';

function Banner() {
  const container = useRef<HTMLDivElement>(null);
  const { locale } = useContext(MyContext);
  const isEn = locale === 'en';

  // useGSAP(() => {
  //   // h1文字和视频 同时渐显 持续1s
  //   // 剩余元素 渐显  持续1s （ fadeClass opacity-0 ）
  //   // 评价自动滚动
  //   // 视频滚动

  useGSAP(
    () => {
      gsap
        .timeline()
        .to(
          '.h1Title',
          {
            opacity: 1,
            duration: 1,
          },
          0,
        )
        .fromTo(
          '.img',
          { scale: 0, transformOrigin: '0% 0%' },
          {
            scale: 1,
            transformOrigin: '0% 0%',
            duration: 0.5,
            ease: 'cubic-bezier(0.250, 0.460, 0.450, 0.940)',
          },
          0,
        )
        .to(
          '.fadeClass',
          {
            opacity: 1,
            duration: 0.8,
          },
          0.4,
        );
    },
    { scope: container },
  );

  const { t } = useTranslation(['chinese', 'path']);

  const classHtml = () => {
    return (
      <div className="fadeClass opacity-0">
        <div
          className={cls(
            'px-5 lg:mt-[50px] lg:px-0 xl:mt-[60px]',
            isEn && 'px-5 lg:px-0 [&]:lg:mt-[40px] [&]:xl:mt-[68px]',
          )}>
          <div className=" text-center lg:text-left">
            <LeadButton
              subject="chinese"
              theme="red"
              size="xl"
              traceName="O_ChineseCourse_FirstModule_CTAClick"
              traceGa4Name="new_entry_ChineseCourse_FirstModuleCTA">
              {t('banner-按钮')}
            </LeadButton>
          </div>
          <div className="mt-[18px] lg:mt-5 lg:[&_a]:justify-start">
            <TrustpilotBar />
          </div>
        </div>
      </div>
    );
  };
  return (
    <section ref={container} className="mt-[124px] lg:mt-[136px] xl:mt-[144px]">
      {/* 内容 */}
      <div
        className={cls(
          'container relative flex flex-col justify-between lg:w-[1024px] lg:flex-row lg:px-[110px] xl:w-[1400px]',
          locale === 'zh'
            ? 'lg:py-[57px] xl:p-[94px_144px]'
            : 'lg:py-[37px] xl:p-[55px_110px]',
        )}>
        <div className="h1Title relative flex-1 opacity-0">
          <div className=" relative z-20 lg:text-left [&]:lg:text-3xl [&]:lg:leading-normal [&]:xl:text-[42px] [&]:xl:leading-normal">
            <Title
              className={cls(
                'relative z-20 lg:text-left [&]:lg:text-3xl [&]:lg:leading-normal [&]:xl:text-[48px] [&]:xl:leading-normal',
                isEn && '[&]:lg:leading-[42px] [&]:xl:leading-[57px]',
              )}
              innerHTML
              theme="red"
              htmlLabel="h1">
              {`${t('banner-主标题')}`}
            </Title>
            <h2
              className={cls(
                'mt-[8px] block text-center text-[16px] leading-[32px] text-wk-words-2 lg:mt-[16px] lg:inline-block lg:text-left lg:text-[16px] lg:leading-normal xl:mt-[24px] xl:inline-block xl:text-left xl:text-[20px]',
                isEn &&
                  'leading-normal xl:w-[490px] [&]:lg:text-[16px] [&]:xl:text-[20px]',
              )}
              dangerouslySetInnerHTML={{ __html: t('banner-副标题') }}
            />
          </div>
          <div className="hidden lg:block">{classHtml()}</div>
        </div>
        <div
          className={cls(
            'my-[24px] lg:absolute lg:bottom-[20px] lg:right-[20px] lg:my-0 lg:h-[368px] lg:w-[468px] xl:absolute xl:bottom-[35px] xl:my-0 xl:h-[500px] xl:w-[640px] ',
            locale === 'zh' ? 'xl:right-[50px]' : 'xl:right-0',
          )}>
          <Image
            src={`/images/chinese/banner-right-${isEn ? 'en' : 'zh'}.png`}
            alt={t('banner-alt')}
            className="h-auto w-full"
            width={0}
            height={0}
            sizes="100vw"
            loading="eager"
            priority
          />
        </div>
      </div>
      <div className="lg:hidden">{classHtml()}</div>
    </section>
  );
}

export default Banner;
